import React, { Component } from 'react'
import {
  Container,
  Grid,
  Segment,
  Form,
  Message,
  Header
} from 'semantic-ui-react'

// redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { loginUser, delLoginMessage } from '../actions/user'

class LoginPage extends Component {
  state = {
    username: '',
    password: ''
  }
  handleChange(e) {
    this.props.delLoginMessage()
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleSubmit(e) {
    if (!(this.state.username.length < 4 || this.state.password.length < 5)) {
      this.props.loginUser(this.state)
      e.preventDefault()
    }
  }

  render() {
    const { loginMessage } = this.props.user
    return (
      <Container fluid className="login-page">
        <Grid centered>
          <Grid.Column
            computer={10}
            className="login-backsplash"
            only="computer"
          >
            <span />
          </Grid.Column>
          <Grid.Column computer={6} tablet={6} mobile={16}>
            <div className="login-box">
              <Header as="h2">Welcome!</Header>
              <p>
                Login using the credentials provided by your system
                administrator:
              </p>
              <Segment>
                <Form>
                  <Form.Input
                    name="username"
                    label="Username"
                    placeholder="Username"
                    onChange={this.handleChange.bind(this)}
                  />
                  <Form.Input
                    name="password"
                    label="Password"
                    placeholder="Password"
                    type="password"
                    onChange={this.handleChange.bind(this)}
                  />
                  <Form.Button
                    fluid
                    onClick={this.handleSubmit.bind(this)}
                    disabled={
                      this.state.username.length < 4 ||
                      this.state.password.length < 5
                    }
                  >
                    Login
                  </Form.Button>
                  {loginMessage
                    ? <Message negative>
                        {loginMessage}
                      </Message>
                    : null}
                </Form>
              </Segment>
              <p style={{ textAlign: 'center' }}>DK Intl.</p>
            </div>
          </Grid.Column>
        </Grid>
      </Container>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    ui: state.ui
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      loginUser,
      delLoginMessage
    },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage)



// WEBPACK FOOTER //
// ./src/pages/Login.jsx